import { SET_EVENT_ITEMS, setEventItemsHandler, SetEventItemsAction } from './event-items';
import {
  SET_EVENT_INVETORY_DETAILS,
  SetEventInvetoryDetailsAction,
  setEventInvetoryDetailsHandler,
} from './get-event-inventory-details';
import {
  SET_FILTER_PRESETS,
  SetFilterPresetsAction,
  setFilterPresetsHandler,
} from './get-filter-presets';
import {
  SET_GET_FORM_CONFIGURATIONS,
  SetGetFormConfigurationsAction,
  setGetFormConfigurationsHandler,
} from './get-form-configurations';
import {
  SET_NOTIFICATION_SETTINGS,
  SetGetNotificationSettingsAction,
  setGetNotificationSettingsHandler,
} from './get-notificaction-settings';
import { SET_USER_INFO, SetUserInfoAction, setUserInfoHandler } from './get-user-info';
import {
  SET_USER_TERRITORY,
  setUsageDetailHandler,
  SetGetUserTerritoryAction,
} from './get-user-territory';
import {
  SET_GET_USER_NOTIFICATION_COUNT,
  setGetUserNotificationCountHandler,
  SetGetUsetNotificationCountAction,
} from './get_user-notification-count';
import { EventInventoryAssociation } from './interface/event-inventory-details';
import { EventItem } from './interface/event-item';
import { FilterPreset } from './interface/filter-preset';
import { FormConfigurationsClass } from './interface/form-configuration';
import { GetUserTerritory } from './interface/get-user-territory';
import { NotificationSettings } from './interface/notification-settings';
import { UserInfo } from './interface/user-info';
import { UserNotificationCount } from './interface/user-notification-count';

export interface AppDataState {
  getUserTerritory: GetUserTerritory[];
  userInfo: Partial<UserInfo>;
  userNotificationCount: Partial<UserNotificationCount>;
  formConfigurations: Partial<FormConfigurationsClass>;
  eventItems: EventItem[];
  notificationSettings: Partial<NotificationSettings>;
  filterPreset: FilterPreset[];
  eventInventoryAssociation: EventInventoryAssociation[];
}

export type AppDataAction =
  | SetGetUserTerritoryAction
  | SetUserInfoAction
  | SetGetUsetNotificationCountAction
  | SetGetFormConfigurationsAction
  | SetEventItemsAction
  | SetGetNotificationSettingsAction
  | SetFilterPresetsAction
  | SetEventInvetoryDetailsAction;

const INITIAL_STATE: AppDataState = {
  getUserTerritory: [],
  userInfo: {},
  userNotificationCount: {},
  formConfigurations: {},
  eventItems: [],
  notificationSettings: {},
  filterPreset: [],
  eventInventoryAssociation: [],
};

export const appDataReducer = (
  state: AppDataState = INITIAL_STATE,
  action: AppDataAction
): AppDataState => {
  switch (action.type) {
    case SET_USER_TERRITORY:
      return setUsageDetailHandler(state, action);
    case SET_USER_INFO:
      return setUserInfoHandler(state, action);
    case SET_GET_USER_NOTIFICATION_COUNT:
      return setGetUserNotificationCountHandler(state, action);
    case SET_GET_FORM_CONFIGURATIONS:
      return setGetFormConfigurationsHandler(state, action);
    case SET_EVENT_ITEMS:
      return setEventItemsHandler(state, action);
    case SET_NOTIFICATION_SETTINGS:
      return setGetNotificationSettingsHandler(state, action);
    case SET_FILTER_PRESETS:
      return setFilterPresetsHandler(state, action);
    case SET_EVENT_INVETORY_DETAILS:
      return setEventInvetoryDetailsHandler(state, action);
    default:
      return state;
  }
};
